// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  client_id: 'e4f6f764-6da4-40f6-82fd-11b7ea5dd9cd',
  app_url: 'https://localhost:4200',
  base_api_url: 'https://localhost:4200/api',
  base_api_scope: 'api://chem-supplier-api-nonprod/access_as_user',
  noti_api_scope: 'api://chem-notification-engine-dev/access_as_user',
  base_api_swagger: 'https://localhost:5001/swagger/v1/swagger.json',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
